var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hasAnyPraticaAndGeoJsonImovel
    ? _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "el-card",
            { staticClass: "m-2", staticStyle: { width: "500px" } },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c("h2", { staticClass: "titulo" }, [
                    _c("i", {
                      staticClass: "far fa-exclamation-triangle",
                      staticStyle: { color: "orange" }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(_vm.info.title))])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", [_c("p", [_vm._v(_vm._s(_vm.info.message))])])
            ]
          )
        ],
        1
      )
    : _c(
        "validation-observer",
        {
          ref: "localObserver",
          staticClass: "sedap-georreferenciamento-form",
          attrs: { tag: "div" }
        },
        [
          _c("TitleWithRow", {
            staticClass: "sedap-georreferenciamento-form__title",
            attrs: {
              title: "Georreferenciamento das práticas realizadas na área"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sedap-georreferenciamento-form__instructions" },
            [
              _c("p", [
                _vm._v(
                  "Faça o georreferenciamento de cada prática dentro dos limites do seu imóvel, desenhando ou fazendo o upload da área correspondente."
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "sedap-georreferenciamento-form__instructions__steps"
                },
                [
                  _c("p", [_vm._v("Siga os seguintes passos:")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sedap-georreferenciamento-form__instructions__steps-row"
                    },
                    [
                      _c("p", [_vm._v("1. Selecione a prática")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Clique no botão de edição (ícone de lápis) ao lado da prática desejada na lista (ex: Recuperação de Pastagens Degradadas - PRPD)."
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sedap-georreferenciamento-form__instructions__steps-row"
                    },
                    [
                      _c("p", [_vm._v("2. Faça o georreferenciamento")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          'Clique no botão "Desenhar polígono" para desenhar a área diretamente no mapa ou clique no botão "Importar shape" para fazer o upload do seu arquivo vetorial (shapefile ou .kml).'
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sedap-georreferenciamento-form__instructions__steps-row"
                    },
                    [
                      _c("p", [_vm._v("3. Finalize o georreferenciamento")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          'Se desenhou a área ou fez upload do arquivo, clique em "Finalizar edição" e depois em "Salvar" para concluir.'
                        )
                      ])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.spsList.length
            ? _c("Map", {
                key: _vm.mapKey,
                ref: "mapComponent",
                attrs: {
                  pratices: _vm.spsList,
                  propertyShapeImovel: _vm.propertyShapeImovel
                },
                on: {
                  updateAreas: _vm.updateVectorizedAreas,
                  renderPratices: _vm.renderPratices
                }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4298cf62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4298cf62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/georreferenciamento/georreferenciamento.vue
// module id = null
// module chunks = 